<mbs-modal
  #modal
  [isCustomModal]="true">
  <ng-container modal-header>{{ 'mbs-ui:cloud-restore.addDestinationModal.title' | i18next }}</ng-container>

  <ng-container modal-body>
    @if (error) {
      <mbs-alert
        [icon]="true"
        [type]="popupType.danger">
        {{ this.error }}
      </mbs-alert>
    }

    <ng-template #bucketNameLabel>
      <span class="d-flex mw-100 overflow-hidden">
        <mbs-text-ellipsis>
          {{ 'mbs-ui:cloud-restore.addDestinationModal.label' | i18next: { region: params.regionName } }}
          <ng-template mbsTextEllipsisAppend>
            <span
              class="ico ico-info-circle ml-2 cursor-help text-info"
              container="body"
              tooltipClass="tooltip-xl"
              [ngbTooltip]="rules"
              [placement]="'left'"></span>
            <ng-template #rules>
              <ul class="text-start m-0 p-3">
                @for (item of bucketNameRules; track item; let last = $last) {
                  <li class="text-md ml-2 mb-1 pb-0">
                    {{ item }}
                    @if (!last) {
                      <br />
                    }
                  </li>
                }
              </ul>
            </ng-template>
          </ng-template>
        </mbs-text-ellipsis>
      </span>
    </ng-template>
    <mbs-input
      [formControl]="bucketName"
      [label]="bucketNameLabel"></mbs-input>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      type="secondary"
      (click)="modal.close()">
      {{ 'shared:buttons.close' | i18next }}
    </mbs-button>

    <mbs-button
      type="primary"
      [disabled]="!bucketName?.valid || !bucketName?.value"
      [loading]="loading"
      (click)="add()">
      {{ 'shared:buttons.add' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
